import React     from 'react'
import PropTypes from 'prop-types'

import { translateBool, formatDate        } from 'alto-utils/lib/utils'
import { AdminForm, AdminTable, AdminPage } from 'alto-react-components/lib/components'
import KreditRepository, { Transaction }    from 'alto-react-kredit/lib/models'

class TransactionTable extends AdminTable
  @contextTypes = { backend: PropTypes.object }

  model:       Transaction
  allowCreate: false
  allowEdit:   false
  allowDelete: false

  constructor: (props, context) ->
    super(props, context)

    @state.kinds           = null
    @state.ready           = false
    @state.notReadyMessage = 'Načítám typy transakcí'

    context.backend.requestWithAuth('GET', '/kredit/get_transaction_kinds')
      .then ({ kinds }) => @setState({ kinds, ready: true })

  columns: ->
    [{
       _property: 'client.firstname'
       property: (transaction) -> transaction.associations.client.firstname
       header:
         label: 'Jméno klienta'
         formatters: [@orderableAndFilterable()]
       filter:
         matcher: 'icontains'
     }, {
       _property: 'client.surname'
       property: (transaction) -> transaction.associations.client.surname
       header:
         label: 'Příjmení klienta'
         formatters: [@orderableAndFilterable()]
       filter:
         matcher: 'icontains'
     }, {
       _property: 'client.clientId'
       property: (transaction) -> transaction.associations.client.clientId
       header:
         label: 'Číslo klienta'
         formatters: [@orderableAndFilterable()]
       filter:
         matcher: 'icontains'
     }, {
       property: 'kind'
       header:
         label: 'Typ'
         formatters: [@orderableAndFilterable(type: 'select', options: @state.kinds.map (kind) -> [kind, kind])]
       filter:
         matcher: 'icontains'
     }, {
       property: 'amount'
       header:
         label: 'Obnos'
         formatters: [@orderableAndFilterable()]
       cell:
         formatters: [(amount) -> amount.toFixed(2)]
       filter:
         matcher: 'icontains'
     }, {
       property: 'balance'
       header:
         label: 'Zůstatek'
         formatters: [@orderableAndFilterable()]
       cell:
         formatters: [(balance) -> balance.toFixed(2)]
       filter:
         matcher: 'icontains'
     }, {
       property: 'transactedAt'
       header:
         label: 'Vytvořena'
         formatters: [@orderableAndFilterable(type: 'date')]
       cell:
         formatters: [(moment) -> moment.format('D.M.YYYY H:mm')]
       filter:
         matcher: 'icontains'
     }, {
       property: 'description'
       header:
         label: 'Číslo účtu'
         formatters: [@orderableAndFilterable()]
       filter:
         matcher: 'icontains'
     }, {
       property: 'displayDescription'
       header:
         label: 'Komentář'
         formatters: [@orderableAndFilterable()]
       filter:
         matcher: 'icontains'
     }]

class TransactionForm extends AdminForm
  @contextTypes = { backend: PropTypes.object }

  model: Transaction

  constructor: (props, context) ->
    super(props, context)

    @state.kinds           = null
    @state.ready           = false
    @state.notReadyMessage = 'Načítám seznam jídel'

    context.backend.requestWithAuth('GET', '/kredit/get_transaction_kinds')
      .then ({ kinds }) => @setState({ kinds, ready: true })

  inputs: ->
    [{
       type:      'static'
       label:     'Klient'
       property:  'clientID'
       formatter: (id, transaction) ->
         client = transaction.associations.client
         "#{client.fullName} (#{client.clientId})"
     }, {
       type:      'select'
       label:     'Typ'
       property:  'kind'
       options:   @state.kinds.map (kind) -> [kind, kind]
     }, {
       label:     'Obnos'
       property:  'amount'
       type:      'integer'
       validator: 'notEmpty'
       allowZero: true
     }, {
       label:     'Zůstatek'
       property:  'balance'
       type:      'integer'
       validator: 'notEmpty'
       allowZero: true
     }]

export default class TransactionManagement extends AdminPage
  @contextTypes = { backend: PropTypes.object }

  tableComponent: TransactionTable
  formComponent:  TransactionForm

  relation: ->
    @__relation ?= KreditRepository.forBackend(@context.backend).transactions.with('client')
